export default function CTASection() {
  return (
    <section className="bg-background-50 py-16 md:py-28 px-4 md:px-10">
      <div className="max-w-4xl mx-auto text-center">
        {/* Visual Container */}
        <div className="relative w-full h-[320px] md:h-[400px] rounded-3xl overflow-hidden mb-14">
          <img
            src="https://readdy.ai/api/search-image?query=Serene%20minimalist%20flat%20lay%20with%20soft%20organic%20linen%20texture%20and%20elegant%20natural%20accessories%2C%20warm%20diffused%20window%20light%2C%20lifestyle%20editorial%20photography%2C%20sage%20green%20and%20warm%20sand%20tones%2C%20clean%20harmonious%20composition%2C%20delicate%20dried%20botanical%20accents&width=1400&height=800&seq=cta-final-fresh-v2-19&orientation=landscape"
            alt="Superbuy Spreadsheet product research lifestyle"
            title="Superbuy Spreadsheet - Start your product research"
            className="w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-black/30 to-transparent"></div>
        </div>

        {/* Text */}
        <h2 className="font-heading text-3xl md:text-5xl font-bold text-foreground-950 leading-tight max-w-2xl mx-auto">
          Ready to discover the power of{' '}
          <span className="italic text-primary-500">Superbuy</span>{' '}
          <span className="italic text-primary-500">Spreadsheet</span>?
        </h2>
        <p className="mt-4 text-foreground-500 text-sm md:text-base max-w-lg mx-auto">
          Start exploring organized product categories and make smarter shopping decisions today
        </p>

        {/* CTA */}
        <a
          href="https://kaspreadsheet.com"
          target="_blank"
          rel="noopener nofollow"
          className="inline-flex items-center gap-2 mt-8 px-10 py-4 bg-foreground-950 text-background-50 rounded-full text-base font-semibold whitespace-nowrap cursor-pointer hover:bg-foreground-800 transition-colors"
        >
          Start Your Product Research
          <i className="ri-arrow-right-up-line text-lg"></i>
        </a>
      </div>
    </section>
  );
}